import { render } from "./GlStatus.vue?vue&type=template&id=a0f86fc6&scoped=true"
import script from "./GlStatus.vue?vue&type=script&lang=js"
export * from "./GlStatus.vue?vue&type=script&lang=js"

import "./GlStatus.vue?vue&type=style&index=0&id=a0f86fc6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a0f86fc6"

export default script